import { render, staticRenderFns } from "./privacy_policy.vue?vue&type=template&id=86efe2d0&scoped=true&"
import script from "./privacy_policy.vue?vue&type=script&lang=js&"
export * from "./privacy_policy.vue?vue&type=script&lang=js&"
import style0 from "./privacy_policy.vue?vue&type=style&index=0&id=86efe2d0&prod&scoped=true&lang=css&"
import style1 from "./privacy_policy.vue?vue&type=style&index=1&id=86efe2d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86efe2d0",
  null
  
)

export default component.exports